<i18n>
{
    "uk": {
        "trial": {
            "title": "Спробуйте навчання з Креативною Практикою безплатно",
            "text": "Пробний період триватиме 7 днів. Ми відкриємо вам доступ до всіх курсів та платних можливостей платформи. При цьому вам не потрібно залишати ваш номер кредитної картки чи робити тестовий платіж, щоб активувати тестовий період. Оформите передплату потім, якщо все сподобається!",
            "b1": "Почати пробний період",
            "b2": "Більше про передплату"
        }
    },
    "en": {
        "trial": {
            "title": "Try learning with Creative Practice for free",
            "text": "The trial period will last 7 days. You will gain access to all courses and all paid features of the platform. And you even do not have to leave your credit card number to activate the trial period. Make a subscription later if you like everything.",
            "b1": "Start trial",
            "b2": "More about subscription"
        }
    }
}
</i18n>

<template>
    <cases-panel
        modal-name="subscription-trial"
        side="right"
        :classes="['h-100', 'headless']"
    >
        <div class="h-100 d-flex flex-column">
            <div class="p-3">
                <div class="trial-image">
                    <img class="block-image scheme-light-block mx-auto" src="/images/creative-practice/subscription/about-light.png" alt="" width="280" height="280" loading="lazy">
                    <img class="block-image scheme-dark-block mx-auto" src="/images/creative-practice/subscription/about-dark.png" alt="" width="280" height="280" loading="lazy">
                </div>
                <h3 class="fw-800 my-1 trial-title">{{ $t('trial.title') }}</h3>
                <p>
                    {{ $t('trial.text') }}
                </p>
            </div>
            <div class="trial-footer px-3 py-2 mt-auto d-flex flex-column elevate w-100">
                <button
                    class="btn-primary fw-700 w-100"
                    @click="startTrial"
                >
                    <span class="mr-h color-gray-3 icon-ic-video" />
                    {{ $t('trial.b1') }}
                </button>

                <nuxt-link
                    :to="localePath('/learning/subscription')"
                    class="btn-bg tt-upper fw-700 w-100 mr-2 elevate mt-1"
                >
                    {{ $t('trial.b2') }}
                </nuxt-link>
            </div>
        </div>
    </cases-panel>
</template>

<script>
import CasesPanel from '~/components/panels/CasesPanel.vue';

export default {
    components: {CasesPanel},

    methods: {
        startTrial () {
            if (!this.$auth.user) {
                return this.$modalityStore.openModal({
                    type: 'drawer',
                    name: 'login',
                    message: 'login.401.preBuy'
                });
            }

            this.$axios.$post('/access/trial')
            .then(res => {
                this.$modalityStore.closeModal({type: 'drawer'})

                this.$gtag('event', 'activate_trial', {
                    'trial_period': '7 days'
                })

                this.$fbPixel.trackSingle('StartTrial');
            })
            .catch(err => {
                console.log(err);
            })
        }
    }
}
</script>

<style scoped>
    .trial-image {
        overflow: hidden;
        border-radius: 8px;
    }

    .trial-footer {
        position: sticky;
        bottom: 0;
        box-shadow: 0px 0px 0px 1px rgba(14, 16, 20, 0.04),
                    0px 0px 2px rgba(14, 16, 20, 0.08),
                    0px 4px 12px rgba(14, 16, 20, 0.08);
    }

    .trial-title {
        font-size: 19px;
        line-height: 24px;
    }
</style>
